<div class="whisper-field px-2 py-2">
  <div class="d-flex align-items-center gap-1 small text-muted mb-1">
    <i class="ri-chat-private-line whisper-marker"></i>
    <span class="fw-bold text-nowrap whisper-marker">
      {{
        (editing
          ? "attendance.whisper.editing"
          : replyTo
            ? "attendance.whisper.replying"
            : "attendance.whisper.marker"
        ) | translate
      }}
    </span>
    @if (editing) {
      <span class="text-truncate">· {{ editing.content | truncate: 60 }}</span>
    } @else if (replyTo) {
      <span class="text-truncate">· {{ replyTo.user?.name }}: {{ replyTo.content | truncate: 60 }}</span>
    }
    <span class="ms-auto text-nowrap">
      <i class="ri-eye-off-line me-1"></i>{{ "attendance.whisper.privacyNotice" | translate }}
    </span>
    <button
      type="button"
      class="btn btn-link btn-sm p-0 text-muted"
      [attr.aria-label]="'attendance.whisper.cancel' | translate"
      (click)="cancel()"
    >
      <i class="ri-close-line"></i>
    </button>
  </div>

  <textarea
    class="form-control"
    rows="2"
    [formControl]="content"
    [maxlength]="maxLength"
    [placeholder]="'attendance.whisper.placeholder' | translate"
    (keydown.enter)="onEnter($event)"
  ></textarea>

  <div class="d-flex align-items-center mt-1">
    <small class="text-muted d-block text-end ms-auto me-2">{{ content.value?.length ?? 0 }} / {{ maxLength }}</small>
    <button type="button" class="btn btn-primary btn-sm" [disabled]="!canSend" (click)="send()">
      @if (!sending) {
        <i class="ri-send-plane-2-line me-1"></i>{{ "attendance.whisper.send" | translate }}
      } @else {
        <span class="spinner-border spinner-border-sm" role="status"></span>
      }
    </button>
  </div>
</div>
